var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99935 4.83366H13.9993V6.50033H3.99935V4.83366Z",
    fill: "#567AE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3327 8.16699H3.99935V9.83366H12.3327V8.16699Z",
    fill: "#567AE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34439 18.7003C4.20955 18.8175 3.99935 18.7218 3.99935 18.5431V14.0003H1.49935C1.03911 14.0003 0.666016 13.6272 0.666016 13.167V1.50033C0.666016 1.04009 1.03911 0.666992 1.49935 0.666992H16.4993C16.9596 0.666992 17.3327 1.04009 17.3327 1.50033V13.167C17.3327 13.6272 16.9596 14.0003 16.4993 14.0003H9.74935L4.34439 18.7003ZM5.66602 12.3337V15.3424L9.12606 12.3337H15.666V2.33366H2.33268V12.3337H5.66602Z",
    fill: "#567AE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsIcon);
export default __webpack_public_path__ + "static/media/commentsIcon.541082fb.svg";
export { ForwardRef as ReactComponent };